
import { Options } from "vue-class-component";
import { SubmitBar, Field, Divider, DatetimePicker, Popup, Toast } from "vant";
import BasePage from "@/common/BasePage";
import ServeItem from "@/components/item/ServeItem.vue";
import TenantVo from "@/vo/TenantVo";

import AppUtil from "@/util/AppUtil";

@Options({
  components: {
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,

    [SubmitBar.name]: SubmitBar,
    [Field.name]: Field,
    [Divider.name]: Divider,
    "serve-item": ServeItem,
  },
})
/**套餐服务预约 */
export default class AddOrder extends BasePage {
  border = false;
  /**支付选项等 */
  config = {
    /**是否显示日期选择 */
    showDate: false,
    /**是否显示时间选择 */
    showTime: false,
    payIdx: 0,
    payArr: [
      { title: "微信支付", url: "/zhPay/wxpay/wxJSAPIPay" },
      //   { title: "会员卡支付", url: "/zhPay/beautyCardPay/gotoPay" },
      //   { title: "股本支付", url: "/zhPay/shareholderCapitalPay/gotoPay" },
    ],
    /**用于提交订单 */
    orderData: {
      /**到店日期 */
      arrivalDate: "",
      /**服务时间 */
      arrivalTime: "",
      orderName: "",
      orderPhone: "",
      orderType: 2,
      serveJson: "",
      packageOrderId: 0,
    },
    /**当前日期 */
    curDate: new Date(),
    /**七天后的日期 */
    date7: new Date(new Date().getTime() + 86400000 * 7),
  };
  tenantInfo: TenantVo = TenantVo.getInstance();
  mounted() {
    if (!this.serveArr.length) {
      this.$toast("缺少服务信息");
      setTimeout(() => {
        this.$router.replace({
          path: "/package/user",
        });
      }, 2000);
    }

    // console.log("serveArr", this.serveArr);
    // if(!this.serveArr.length){

    // }
     const params = JSON.parse(localStorage.getItem('params')||'');
    this.config.orderData.packageOrderId = params.packageOrderId;
  }
  /**选中的服务列表 */
  public get serveArr(): any[] {
    // console.log('this.$route.params1', this.$route.params);
    let q = localStorage.getItem('params');
    if(!q){
      return [];
    }

    const params=JSON.parse(q);
    if (params.serveArr) {
      let arr = JSON.parse(params.serveArr);
      arr.map((val: any) => {
        val.thumb = AppUtil.get_thumb(val.serveLogo, 250, 325);
        let goodsDesc = "";
        let goodArr = JSON.parse(val.goodsList);
        goodArr.map((good: any) => {
          goodsDesc += good.goodsName + "*" + good.goodsNum + ";";
        });
        val.serveNum = val.num;
        val.goodsDesc = goodsDesc;
        return val;
      });
      return arr;
    }

    return [];
  }
  public get num() {
    let num = 0;
    this.serveArr.map((val: any) => {
      num += val.num * 1;
    });
    return num;
  }
  // public get price() {
  //   let num = 0;
  //   this.appVo.serveArr.map((val: any) => {
  //     num += val.price * val.serveNum;
  //   });
  //   return num;
  // }
  /**用于日期选择组件 */
  date_formatter(type: string, val: number) {
    if (type === "month") {
      return `${val}月`;
    }
    if (type === "day") {
      return `${val}日`;
    }
    return val;
  }
  private submit_date(date: Date) {
    console.log("选中的submit_date", date);

    // this.config.showDate = false;
    // this.config.orderData.arrivalDate =
    //   date.getFullYear() +
    //   "/" +
    //   (date.getMonth() * 1 + 1) +
    //   "/" +
    //   date.getDate();
    this.config.showDate = false;
    let hour=date.getHours();
    if(hour<this.tenantInfo.startHour){
      Toast("您选择的时间早于开店时间，已自动为您调整");
      hour=this.tenantInfo.startHour;
    }else if(hour>this.tenantInfo.endHour){
      Toast("您选择的时间晚于关店时间，已自动为您调整");
      hour=this.tenantInfo.endHour-1;
    }
     this.config.orderData.arrivalTime = hour+":"+date.getMinutes();
     this.config.orderData.arrivalDate=date.getFullYear() + "/" + (date.getMonth()*1+1) + "/" + date.getDate();
     
      this.arrivalDate=this.config.orderData.arrivalDate+" "+this.config.orderData.arrivalTime;
  }
  private submit_time(time: string) {
    // console.log("选中的事件",val);
    this.config.showTime = false;
    this.config.orderData.arrivalTime = time;
  }
  /**提交订单 */
  private submit_click() {
    // [{"id":1,"serveNum":2},{"id":2,"serveNum":2}]
    let arr: any[] = [];
    this.serveArr.map((val: any) => {
      arr.push({ id: val.id, serveNum: val.serveNum });
    });
    this.config.orderData.serveJson = JSON.stringify(arr);
    AppUtil.request(
      {
        url: "/zhOrder/serveOrder/createServeOrder",
        method: "post",
        data: this.config.orderData,
      },
      (res: any) => {
        Toast("预约成功,正在返回");
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      },
      "系统正在为您火速安排..."
    );
  }
}
